import classNames from 'classnames'
import React, { useRef, useState } from 'react'
import { Edit } from '../../icons'
import ExpandIcon from '../Position/ExpandIcon'

interface BoxWithTitleProps extends React.PropsWithChildren {
	title: string
	size?: 'small' | 'medium' | 'large'
	id?: string
	edit?: boolean
	expandable?: boolean
	onClick?: () => void
}

export const BoxWithTitle: React.FC<BoxWithTitleProps> = ({
	title,
	children,
	id = '',
	edit = false,
	size = 'large',
	expandable = false,
	onClick = () => null,
}) => {
	const [isOpen, setIsOpen] = useState(true)
	const contentRef = useRef<HTMLDivElement>(null)

	const toggleOpen = () => {
		setIsOpen(!isOpen)
	}

	return (
		<div className="bg-white rounded-[10px] overflow-hidden p-[5px] shadow-lg">
			<div id={id} className="relative -top-24 [visibility:hidden]" />
			<div
				className={classNames('relative flex font-semibold text-brand-gray-400 items-center', {
					'text-sm md:text-base p-5': size === 'small',
					'text-base md:text-lg p-6': size === 'medium',
					'text-lg md:text-xl p-7': size === 'large',
				})}
			>
				<div className="absolute -left-1.5 w-1 h-full top-0 bg-brand-secondary" />
				{expandable && (
					<button type="button" className="flex items-center h-2 mr-2" onClick={toggleOpen} aria-label="Toggle expand">
						<span className={classNames('transition-transform', { 'rotate-90': isOpen })}>
							<ExpandIcon size="md" />
						</span>
					</button>
				)}
				{title}
				{edit && (
					<button type="button" className="flex items-center h-2 ml-auto" onClick={onClick}>
						<Edit />
					</button>
				)}
			</div>
			<div
				ref={contentRef}
				className={classNames(
					'overflow-hidden text-xs transition-[max-height] duration-200 ease-in-out md:text-sm text-brand-gray-300',
					{
						'max-h-0': !isOpen,
						'max-h-[2000px]': isOpen,
					},
				)}
			>
				<hr />
				{children}
			</div>
		</div>
	)
}
